import React, { useEffect, useState } from 'react';

const LoadingDots = () => {
  const [dots, setDots] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      setDots(prev => prev.length >= 3 ? '' : prev + '.');
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="min-h-[24px] flex items-center">
      <span className="text-gray-600 text-lg leading-relaxed">
        {dots || ''}
      </span>
    </div>
  );
};

export default LoadingDots;
